import { render } from "./OptionsQuestion.vue?vue&type=template&id=8f996e9e&ts=true"
import script from "./OptionsQuestion.vue?vue&type=script&lang=ts"
export * from "./OptionsQuestion.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__